import React from 'react';

const RegrasImportMassaInicial = () => (
  <>
    <p>
      Realize o envio da
      <strong> massa inicial </strong>
      através do envio de um arquivo
      <strong> .csv </strong>
      de até <strong> 10mb</strong>.
    </p>
    <p>
      O arquivo não deve possuir linhas <strong>&apos;em branco&apos; </strong>{' '}
      e não deve possuir linhas contento apenas{' '}
      <strong>ponto e vírgula(;).</strong>
    </p>
  </>
);

export default RegrasImportMassaInicial;
